import { Flex, Grid, Paper, Text, Title } from "@mantine/core";

export default function WhoWeAreSection() {
  return (
    <Flex py={60} px="xl" maw={1200} mx="auto" w="100%">
      <Flex
        justify="space-between"
        align="flex-start"
        gap={{ base: "xl", md: 60 }}
        direction={{ base: "column", md: "row" }}
        w="100%"
      >
        <Flex direction="column" gap="md" flex={1}>
          <Title order={2}>Who We Are</Title>
          <Text c="slate.6">
            GT Setu is a global B2B collaboration platform designed to connect verified manufacturers, suppliers, and
            business partners in a secure and trusted environment.
          </Text>
          <Text c="slate.6">
            We enable companies to discover potential partners anonymously, verify their credentials through our
            compliance framework, and collaborate confidentially through our structured workspace.
          </Text>
          <Text c="slate.6">
            Our mission is to eliminate the friction and risk in cross-border business development by providing a
            verification-first platform where trust is built into every interaction.
          </Text>
        </Flex>

        <Grid gutter="md" flex={1}>
          <Grid.Col span={{ base: 6, md: 6 }}>
            <Paper
              radius="lg"
              p="lg"
              h="100%"
              style={{ textAlign: "center", backgroundColor: "var(--mantine-color-primary-0)" }}
            >
              <Text fw={700} fz="xl" c="primary" mb="xs">
                500+
              </Text>
              <Text fz="sm" c="slate.6">
                Verified Companies
              </Text>
            </Paper>
          </Grid.Col>
          <Grid.Col span={{ base: 6, md: 6 }}>
            <Paper
              radius="lg"
              p="lg"
              h="100%"
              style={{ textAlign: "center", backgroundColor: "var(--mantine-color-primary-0)" }}
            >
              <Text fw={700} fz="xl" c="primary" mb="xs">
                35+
              </Text>
              <Text fz="sm" c="slate.6">
                Countries
              </Text>
            </Paper>
          </Grid.Col>
          <Grid.Col span={{ base: 6, md: 6 }}>
            <Paper
              radius="lg"
              p="lg"
              h="100%"
              style={{ textAlign: "center", backgroundColor: "var(--mantine-color-primary-0)" }}
            >
              <Text fw={700} fz="xl" c="primary" mb="xs">
                1,200+
              </Text>
              <Text fz="sm" c="slate.6">
                Connections Made
              </Text>
            </Paper>
          </Grid.Col>
          <Grid.Col span={{ base: 6, md: 6 }}>
            <Paper
              radius="lg"
              p="lg"
              h="100%"
              style={{ textAlign: "center", backgroundColor: "var(--mantine-color-primary-0)" }}
            >
              <Text fw={700} fz="xl" c="primary" mb="xs">
                98%
              </Text>
              <Text fz="sm" c="slate.6">
                Success Rate
              </Text>
            </Paper>
          </Grid.Col>
        </Grid>
      </Flex>
    </Flex>
  );
}
